
(() => {
  let bannerReady;

  function loadBanner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (!bannerReady) {
      bannerReady = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        script.onload = () => window.privacyBanner?.showPreferences
          ? resolve() : reject(new Error('Cookie preferences API unavailable'));
        script.onerror = () => reject(new Error('Cookie preferences failed to load'));
        document.head.appendChild(script);
      }).catch((error) => { bannerReady = undefined; throw error; });
    }
    return bannerReady;
  }

  class CookieConsent extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.mountPreferences(), { once: true });
      } else {
        this.mountPreferences();
      }
    }

    mountPreferences() {
      if (!this.isConnected) return;
      if (document.getElementById('sa-cookie-preferences')) return;
      const policyLink = document.querySelector('footer a[href*="/pages/privacy"], footer a[href*="/policies/privacy-policy"]');
      const policyItem = policyLink?.closest('li');
      if (!policyItem) return;

      const language = document.documentElement.lang.split('-')[0];
      const labels = {
        en: ['Cookie preferences', 'Unable to open cookie preferences. Please try again.'],
        pl: ['Ustawienia plików cookie', 'Nie można otworzyć ustawień. Spróbuj ponownie.'],
        uk: ['Налаштування cookie', 'Не вдалося відкрити налаштування. Спробуйте ще раз.'],

        ru: ['Настройки cookie', 'Не удалось открыть настройки. Попробуйте ещё раз.'],
        et: ['Küpsiste eelistused', 'Eelistusi ei õnnestunud avada. Proovi uuesti.'],
      }[language] || ['Cookie preferences', 'Unable to open cookie preferences. Please try again.'];
      const item = document.createElement('li');

      item.className = [policyItem.className, 'sa-cookie-pref'].filter(Boolean).join(' ');
      const button = document.createElement('button');
      const status = document.createElement('span');
      button.id = 'sa-cookie-preferences';
      button.type = 'button';
      button.textContent = labels[0];
      button.style.cssText = 'font:inherit;color:inherit;background:none;border:0;padding:0;cursor:pointer;text-align:inherit';
      status.setAttribute('role', 'status');
      status.style.display = 'block';
      item.append(button, status);
      policyItem.after(item);

      button.addEventListener('click', async () => {
        button.disabled = true;
        status.textContent = '';
        try {
          await loadBanner();
          await window.privacyBanner.showPreferences();
        } catch (error) {
          status.textContent = labels[1];
          console.warn('[Cookie preferences]', error);
        } finally {
          button.disabled = false;
        }
      });
    }
  }

  if (!customElements.get('cookie-consent')) customElements.define('cookie-consent', CookieConsent);
})();
